import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, FormFeedback, Alert } from 'reactstrap';
import FaPencilAlt from "../../imgs/lapiz.svg"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

//import DataJson from './suspensionJson';

class TablaPrioridad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],

            modalNamRol: "",
            modalTiempo: "",
            invalidNamArea: false,
            invalidPassword: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalEditar = this.modalEditar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.editarSeleccion = this.editarSeleccion.bind(this);
        this.handleChangeModal = this.handleChangeModal.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleChangeModal(e) {
        const idVariable = e.target.name;
        switch (idVariable) {
            case "modalNamRol":
                if (e.target.value.length <= 32) {
                    await this.setState({
                        modalNamRol: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Rol</Label>
                                            <Input disabled invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNamRol} bsSize="sm" type="text" name="modalNamRol" id="modalNamRol" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 32 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Tiempo de prioridad</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalTiempo} bsSize="sm" type="text" name="modalTiempo" id="modalTiempo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 1 a 2 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            case "modalTiempo":
                if (e.target.value.length <= 2) {
                    await this.setState({
                        modalTiempo: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Rol</Label>
                                            <Input disabled invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNamRol} bsSize="sm" type="text" name="modalNamRol" id="modalNamRol" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 32 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Tiempo de prioridad</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalTiempo} bsSize="sm" type="text" name="modalTiempo" id="modalTiempo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 1 a 2 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando datos, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/tiposUsuarios");
            //const response = { DataJson }
            await this.setState({
                datosTraidos: response.data
                //datosTraidos: response.DataJson
            })
            //console.log(response)
            if (bool === true) {
                this.toggle();
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }
    }

    async modalEditar(event) {
        const datos = event.target.id;
        const arrayDatos = datos.split("///");
        await this.setState({
            auxSeq: arrayDatos[0],
            modalNamRol: arrayDatos[1],
            modalTiempo: arrayDatos[2],
        })
        this.setState({
            invalidNamArea: false,
            invalidPassword: false,
            modalTitulo: "Editar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Rol</Label>
                                <Input disabled invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNamRol} bsSize="sm" type="text" name="modalNamRol" id="modalNamRol" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 32 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Tiempo de prioridad</Label>
                                <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalTiempo} bsSize="sm" type="text" name="modalTiempo" id="modalTiempo" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 1 a 2 Números</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.editarSeleccion} color="warning">Editar</Button>
            </div>
        })
        this.toggle();
    }
    async editarSeleccion() {
        var hayError = false;
        var regexNumber = /^[0-9]+$/;
        //var regexString = /^[a-zA-Z]+$/;
        if (this.state.modalNamRol === undefined || this.state.modalNamRol === "" || this.state.modalNamRol === null || this.state.modalNamRol.length <= 1 || this.state.modalNamRol.length >= 33) {
            hayError = true;
            this.setState({
                invalidNamArea: true,
            })
        } else {
            this.setState({
                invalidNamArea: false,
            })
        }
        if (!this.state.modalTiempo.match(regexNumber) || this.state.modalTiempo === undefined || this.state.modalTiempo === "" || this.state.modalTiempo === null || this.state.modalTiempo.length < 1 || this.state.modalTiempo.length >= 3) {
            hayError = true;
            this.setState({
                invalidPassword: true,
            })
        } else {
            this.setState({
                invalidPassword: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Rol</Label>
                                            <Input invalid={this.state.invalidNamArea} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNamRol} bsSize="sm" type="text" name="modalNamRol" id="modalNamRol" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 32 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Tiempo de prioridad</Label>
                                            <Input invalid={this.state.invalidPassword} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalTiempo} bsSize="sm" type="text" name="modalTiempo" id="modalTiempo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 1 a 2 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                secTipoUsuario: this.state.auxSeq,
                namTipoUsuario: this.state.modalNamRol,
                prioridad: this.state.modalTiempo,
            }
            try {
                const response = await axios.put(OBTENER_URL_SERVICIO + "/tipoUsuario/" + this.state.auxSeq, envioDatos);
                if (response.data.tipo === "Actualizado") {
                    this.setState({
                        modalTitulo: "Actualizado",
                        modalMensaje:
                            <div>
                                <p>¡Dato actualizado con éxito!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "Error") {
                        this.setState({
                            modalTitulo: "Area no encontrada",
                            modalMensaje:
                                <div>
                                    <p>No se encontró el dato para eliminar.</p>
                                    <p>¡Quizás alguien se adelantó!</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    render() {

        var datosTabla =
            <Alert color="primary">
                No hay Prioridades inscritas.
</Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre rol</th>
                            <th>Prioridad</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            return (
                                <tr key={p.secTipoUsuario}>
                                    <th scope="row">{p.secTipoUsuario}</th>
                                    <td>{p.namTipoUsuario}</td>
                                    <td>{p.prioridad}</td>
                                    <td><Button size="sm" color="warning" id={p.secTipoUsuario + "///" + p.namTipoUsuario + "///" + p.prioridad} onClick={this.modalEditar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p.secTipoUsuario + "///" + p.namTipoUsuario + "///" + p.prioridad} alt="editar" /></Button></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
        }

        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Prioridad de Usuarios </Label></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TablaPrioridad;